import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

export default function LinearProgressBar({ value, label }) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(0,0,0,0.6)", // dark transparent overlay
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      {/* Loader box */}
      <Box
        sx={{
          width: 600,
          p: 2,
          borderRadius: 2,
          bgcolor: "background.paper", // white/light background
          boxShadow: 3,
        }}
      >
        {/* Progress bar */}
        <LinearProgress
          variant="indeterminate"
          value={value}
          sx={{
            mt: 1,
            height: 8,
            borderRadius: 5,
            backgroundColor: "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              borderRadius: 5,
              backgroundColor: "#2196f3",
              transition: "width 0.6s ease-in-out",
            },
          }}
        />

        {/* Label only */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            mt: 1,
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
